<!-- ScheduleMessage.vue -->
<script lang="ts" setup>
    //import * as MessageLib from "messagelib"
    import { onMounted } from 'vue';
    import { popAlert } from '../../lib/Notification';

    // Outgoing message methods
    defineExpose({openSchedule,openEmr});

    // EVents from incoming messages
	const emit = defineEmits<{
		(e: "openSchedule", payload: MessageLib.MainWindow.OpenSchedulePayload):void,
		(e: "openEmr", payload: MessageLib.MainWindow.OpenSchedulePayload):void
	}>();
    

    onMounted(()=>{
        // Make sure MessageLib is available
        if ("undefined" === typeof(MessageLib))
        {
            popAlert("MessageLib not available");
            return;
        }
        MessageLib.MainWindow.sink.openSchedule(openScheduleSink);
        MessageLib.MainWindow.sink.openEmr(openEmrSink);
    });

    // Raise message events
	function openScheduleSink(payload: unknown)
	{
        emit("openSchedule", <MessageLib.MainWindow.OpenSchedulePayload>payload);
	}
	function openEmrSink(payload: unknown)
	{
        emit("openEmr", <MessageLib.MainWindow.OpenSchedulePayload>payload);
	}

    // Send Messages
    function openSchedule(payload: MessageLib.MainWindow.OpenSchedulePayload)
    {
        MessageLib.MainWindow.openSchedule(payload);
    }
    function openEmr(payload: MessageLib.MainWindow.OpenSchedulePayload)
    {
       MessageLib.MainWindow.openEmr(payload);
    }
</script>